import React from 'react';
import { RouteProvider } from '../context/RouteContext';
import { GeofenceProvider } from '../context/GeofenceContext';

const DirectoryLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <>
        <GeofenceProvider>
            <RouteProvider>
                {children}
            </RouteProvider>
        </GeofenceProvider>
    </>;
};

export default DirectoryLayout;
